import script from "./SheetPropertyFlip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetPropertyFlip.vue?vue&type=script&setup=true&lang=ts"

import "./SheetPropertyFlip.vue?vue&type=style&index=0&id=52a2b0f0&lang=css"

const __exports__ = script;

export default __exports__